import { PureComponent } from 'preact-compat'
import Button from '@insided/control/uikit/Button'
import { getIdAndContentTypeFromTopics } from '../../utils'
import { bulkResolve } from './service'
import ResolveModal from './ResolveModal'

// eslint-disable-next-line import/no-internal-modules
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'

interface ResolveState {
  showResolveModal: boolean
}
class Resolve extends PureComponent<BulkActionComponentProps, ResolveState> {
  constructor(props: BulkActionComponentProps) {
    super(props)
    this.onResolveBulk = this.onResolveBulk.bind(this)
  }

  state = {
    showResolveModal: false
  }

  showResolveModal(show: boolean) {
    this.setState({ showResolveModal: show })
  }

  onResolveBulk() {
    const { performBulkAction } = this.props
    return performBulkAction({
      onClick: async (topics: []) => await bulkResolve(getIdAndContentTypeFromTopics(topics)),
      successMessage: 'Report(s) successfully resolved.'
    })
  }

  render() {
    const { showResolveModal } = this.state

    return (
      <div>
        <Button
          title={
            <div>
              <Icon icon='checkmark' width={16} height={16} />
              Resolve
            </div>
          }
          size='medium'
          variant='approval'
          className='qa-mark-resolve'
          onClick={() => {
            this.setState({ showResolveModal: true })
          }}
        />
        {showResolveModal && (
          <ResolveModal onResolve={() => this.onResolveBulk()} onClose={() => this.showResolveModal(false)} />
        )}
      </div>
    )
  }
}

export default Resolve
